// Docs: FEATURES.md "App structure" (wake screen game). Personal top lists of
// finished streaks, one per mini-game on the wake screen
// (components/WakeGame.jsx). Only the top of the distribution is kept: the
// live run is ranked against it and told how far the next place is.
export const TOP_STREAKS_KEY = 'gt-wake-top-streaks';
// Pre-leaderboard storage: a single der/die/das best streak. Seeds that
// game's list once.
export const LEGACY_BEST_KEY = 'gt-wake-best-streak';
export const TOP_SIZE = 10;

const byDesc = (a, b) => b - a;

export function readTop(key = TOP_STREAKS_KEY) {
  try {
    const raw = window.localStorage.getItem(key);
    if (raw) {
      const list = JSON.parse(raw);
      if (Array.isArray(list)) {
        return list.filter((n) => Number.isInteger(n) && n > 0).sort(byDesc).slice(0, TOP_SIZE);
      }
    }
    if (key !== TOP_STREAKS_KEY) return [];
    const legacy = Number(window.localStorage.getItem(LEGACY_BEST_KEY)) || 0;
    return legacy > 0 ? [legacy] : [];
  } catch {
    return [];
  }
}

export function writeTop(top, key = TOP_STREAKS_KEY) {
  try {
    window.localStorage.setItem(key, JSON.stringify(top));
  } catch { /* storage unavailable — the list just won't stick */ }
}

// Adds a finished run; keeps the list sorted (best first) and capped.
export function recordRun(top, run) {
  if (!(run > 0)) return top;
  return [...top, run].sort(byDesc).slice(0, TOP_SIZE);
}

// Where the live run `streak` stands against the stored `top` list:
//   rank   — its place (ties share one), or null while it is not on the list
//   record — it beats every stored run
//   need / place — correct answers still needed to reach `place`
//                  (null when there is nothing left to overtake)
export function standing(top, streak) {
  const above = top.filter((v) => v > streak);
  const ranked = streak > 0 && above.length < TOP_SIZE;
  const rank = ranked ? above.length + 1 : null;
  const record = streak > 0 && (top.length === 0 || streak > top[0]);

  let next; // the stored run to overtake
  if (above.length > 0) next = above[above.length - 1];
  else if (streak > 0 && !record) next = streak; // tied with the record: one more beats it
  if (next === undefined) return { rank, record, need: null, place: null };
  return {
    rank,
    record,
    need: next - streak + 1,
    place: top.filter((v) => v > next).length + 1,
  };
}
